import { Component, OnInit, ViewChild } from '@angular/core';
import { HelperService, AppSettings, AuthenticationService, Agents } from '../../../services/_services';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, Route, ActivatedRoute } from "@angular/router";
import { Base64Pipe } from '../../../services/pipes/base64/base64.pipe';

import Swal from 'sweetalert2';

declare var document, $;

@Component({
  selector: 'app-add-user',
  templateUrl: './add-user.component.html',
  styleUrls: ['./add-user.component.css']
})
export class AddUserComponent implements OnInit {

  public regionNo               : any;
  public shifts                 : any = AppSettings.agentShifts;
  public isUpdatingAgent        : any = false;
  public agentId                : any;
  public agentDetails           : any = { name           : '',   email           : '',   phone      : '',   cnic        : '',
                                          address        : '',   bank_detail     : '',   z_user     : '',   z_password  : '',
                                          password       : '',   region          : null, department : null, shift       : null,
                                          designation    : null, team_id         : null, page_price : '',
                                          orders_allowed : '',   conversion_rate : '',   is_secure  : false
                                        };

  public agentDetails_Copy      : any = [];
  public agentForm              : FormGroup;

  // Common Vars
  public browserSub         : any;
  public agentsSub          : any;
  public routerSubscription : any;
  public departments        : any;
  public regions            : any;
  public designations       : any;
  public teams              : any;
  public agents             : any;
  public qa                 : any;
  public loader             : any = false;
  public submitted          : any = false;
  public base64Pipe         : any = new Base64Pipe;

  constructor(
    private authenticationService : AuthenticationService,
    private helperService         : HelperService,
    private agentsService         : Agents,
    private activatedRoute        : ActivatedRoute,
    private router                : Router,
    private formBuilder           : FormBuilder,
  ) {
    this.browserSub = this.authenticationService.isBrowser.subscribe(isBrowser => {
      if (isBrowser) {
        // Get Agents
        this.agentsSub = this.agentsService.agentsS$.subscribe(agents => {
          if (agents) {
            this.departments    = agents.departments;
            this.regions        = agents.regions;
            this.designations   = agents.designations;
            this.teams          = agents.teams;
            this.agents         = agents.agents;
            this.qa             = agents.qa;
          }
        });

        this.routerSubscription = this.activatedRoute.params.subscribe(routeParams => {
          if(this.router.url.indexOf('update-user/') != -1) {
            this.isUpdatingAgent = true;
            if(routeParams.userId) {
              this.agentId = this.base64Pipe.decode(routeParams.userId);
              this.getAgentDetails();
            }
          }
        });
      }
    });
  }

  ngOnInit(): void {
    // Set FormGroup
    this.agentForm = this.formBuilder.group({
                      name              : [null, Validators.required],
                      email             : [null, Validators.required],
                      phone             : [null, Validators.required],
                      cnic              : [null],
                      address           : [null],
                      bank_detail       : [null],
                      z_user            : [null],
                      z_password        : [null],
                      password          : [null, Validators.required],
                      region            : [null, Validators.required],
                      department        : [null, Validators.required],
                      shift             : [null, Validators.required],
                      designation       : [null, Validators.required],
                      team_id           : [null],
                      page_price        : [null],
                      orders_allowed    : [null],
                      conversion_rate   : [null],
                      is_secure         : [null]
                    });
  }

  ngOnDestroy(): void {
    if (typeof this.agentsSub != 'undefined') {
      //prevent memory leak when component destroyed
      this.browserSub.unsubscribe();
      this.agentsSub.unsubscribe();
    }
  }

  getAgentDetails() {
    // Show Loader
    this.loader = true;

    let url = AppSettings.API_ENDPOINT + "admin/get-agent-details";
    let data = { id : this.agentId };

    this.helperService.httpPostRequestsDecryp(url, data).then(resp => {
      if(typeof resp != "undefined") {
        this.agentDetails      = JSON.parse(resp);
        this.agentDetails_Copy = $.extend(true, {},  this.agentDetails);
      }

      // Hide Loader
      this.loader = false;
    });
  }

  resetAgentForm() {
    this.agentDetails = $.extend(true, {},  this.agentDetails_Copy);
    this.submitted    = false;
  }

  // convenience getter for easy access to form fields
  get f() { return this.agentForm.controls; }

  addAgent() {
    // Set Submission True
    this.submitted        = true;

    console.log("---- this.agentDetails: ", this.agentDetails);

    // Stop here if form is invalid
    if (this.agentForm.invalid) {
     return;
    }

    // Show Loader
    this.loader = true;

    let url = AppSettings.API_ENDPOINT + "admin/add-agent";

    this.helperService.httpPostRequestsDecryp(url, this.agentDetails).then(resp => {
        console.log("resp: ", resp);

        if(typeof resp != "undefined") {
          Swal.fire('', 'Agent Updated Successfully', 'success');

          // Update Copy
          this.router.navigate(['/manage-team']);
        } else {
            Swal.fire('', 'Something went wrong. Please try again', 'error');
        }

        // Hide Loader
        this.loader = false;
    }).catch(err => {
        console.log("err: ", err);

        Swal.fire('', JSON.stringify(err.error.errors), 'error');


        // Hide Loader
        this.loader = false;
    });
  }

  updateAgent() {
    // Set Submission True
    this.submitted        = true;

    // Stop here if form is invalid
    if (this.agentForm.invalid) {
     return;
    }

    // Show Loader
    this.loader = true;

    let url = AppSettings.API_ENDPOINT + "admin/update-agent-details";

    this.helperService.httpPostRequestsDecryp(url, this.agentDetails).then(resp => {
        if(typeof resp != "undefined") {
          if(resp)
            Swal.fire('', 'Agent Added Successfully', 'success');
          else
            Swal.fire('', 'Something went wrong. Please try again', 'error');

          // Update Copy
          this.agentDetails_Copy = $.extend(true, {},  this.agentDetails);
        }

        // Hide Loader
        this.loader = false;
    }).catch(err => {
        Swal.fire('', 'Something went wrong. Please try again', 'error');


        // Hide Loader
        this.loader = false;
    });
  }
}
